var Curriculog = Curriculog || {};


Curriculog.WarningDialog = (function ($, _, Backbone, WarningDialog) {
    WarningDialog = Curriculog.Dialog.extend({
        title: 'Warning',
        dialogClass: 'curriculog-dialog warning'
    });
    return WarningDialog;
})($, _, Backbone, Curriculog.WarningDialog || {});